import '../html/js/third_party/jquery-1.11.1.min.js';
import '../html/js/third_party/jquery-ui-1.10.1.custom.js';
import '../html/js/third_party/jquery.ui.touch-punch.min.js';
import '../html/js/third_party/jquery.tabSlideOut.v1.3.js';
import '../html/js/third_party/jquery.tipsy.min.js';
import '../html/js/third_party/moment.min.js';
import 'twig/twig.min.js';
import 'altcha';

import './components/Breadcrumb.js';
import './components/CheckBox.js';
import './components/CommentTextarea.js';
import './components/DialogBox.js';
import './components/ThumbnailImage.js';
import './components/FileThumb.js';
import './components/FileBrowserFile.js';
import './components/FileBrowserChildContainer.js';
import './components/FileBrowserFolder.js';
import './components/FileBrowser.js';
import './components/FolderBreadcrumb.js';
import './components/PassStrength.js';
import './components/PopOver.js';
import './components/ProgressBarCircular.js';
import './components/TaggableTextarea.js';
import './components/TagView.js';
import './components/TextareaButton.js';
import './components/TextInputButton.js';
import './components/TimecodeInput.js';
import './components/TokenInput.js';
import './components/UserAvatar.js';

// Third-party
import 'emoji-picker-element';

// React player
import './player/index';

// React player actions bar
import './player-actions/index';

// React approval panel
import './player-approval/index';
import './player-approval/approvalManager';

// React versions dropdown
import './player-versions/index';

// React info tabs
import './player-info-tabs/index';

// React player nav (prev/next file buttons)
import './player-nav/index';

// Multi-column sync-settings panel — exposes window.mountPlayerSyncSettings
import './player-sync-settings/index';

// Dynamic file loader
import './player-loader/loadFile';

// Synced Session manager — exposes window.mountSyncedSession
import './synced-session';

// Player columns manager (multi-column player) — exposes window.attachPlayerColumnManager
import './player-columns/playerColumnManager';

// Playback sync drift controller — exposes window.computeSyncCorrection.
// Consumed by the sync handler in html/js/player_utils.js for smooth
// rate-based drift correction between columns.
import './player-columns/playbackSyncController';

// React annotations
import './annotations/index';

// React player overlay window
import './overlay-window/index';

// React image viewer
import './image-viewer/index';

// React comment-stream wrapper (file_type_id == 5)
import './comment-stream/index';

// React PDF document viewer (file_type_id == 6)
import './document-viewer/index';

// React plain-text viewer (text/plain mime type)
import './text-viewer/index';

// React download overlay (catch-all unsupported file types)
import './download-overlay/index';

// React captcha audio play/stop button
import './captcha-audio-button/index';

require('tailwindcss/index.css');
require('../sass/base/base.scss');
require('../sass/base/player-layout.scss');
require('../sass/base/hekate-refresh.scss');
